import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { LuCalendarDays } from "react-icons/lu";

import api from '../../services/api';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import LanguageContext from '../../contexts/language';

export default function Agenda() {

    const { language } = useContext(LanguageContext);
    const lang = localStorage.getItem('language');

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    
    const [events, setEvents] = useState([]);

    async function loadEvents(){
        setLoading(true);
        try{
            const response = await api.post(`/events`);
            setEvents(response.data.content.events);
            setLoading(false);
        }catch(err){
            setLoading(false);
        }
    }

    useEffect(() => {
        loadEvents();
    }, []);

    function toggle(id){
        const wrapper = document.querySelector('#event_' + id);
        wrapper.classList.toggle('event-close');
    }

    return (
        <div className="page">
            <Header />
            <div className="content">
                <div className="full mt-60 mb-40 text-center form">
                    <h3 className="title_b mb-20">
                        {language.menu_agenda}
                    </h3>
                    <div className={`all-events mt-10`}>
                        {lang==='pt' ?
                        <div className="event-box-text">
                            <p>A programação completa será transmitida ao vivo a partir das <strong>9h do dia 03 de outubro</strong>. Acompanhe neste endereço</p>
                            <p>A programação está sujeita a ajustes de painelistas e horário, e pode ser alterada sem aviso prévio.</p>
                            <p>Não serão emitidos certificados aos participantes.</p>
                        </div>:
                        <div className="event-box-text">
                            <p>The full schedule will be broadcasted live starting at <strong>9 A.M. on October 3</strong>. Watch it here.</p>
                            <p>The schedule is subject to adjustments in panelists and schedules, and may change without prior notice.</p>
                            <p>Certificates will not be issued to participants.</p>
                        </div>}

                        {events.map(item => (
                        <div key={`events-${item.id}`} className="event-box">
                            <div className="event-container">
                                <div className="event-title">
                                    <LuCalendarDays />
                                    <span>{lang==='pt' ? item.title : item.title_en}</span>
                                </div>
                            </div>
                            {item.event.map(event => (
                            <div key={`event-${event.id}`} className={`event-content dont-click`}>
                                <div className={`event-hour ${lang}`}>
                                    {event.time_start==event.time_end ?
                                    <span>{lang==='pt' ? event.time_start : event.time_start_en}</span>:
                                    <span>{lang==='pt' ? event.time_start : event.time_start_en} - {lang==='pt' ? event.time_end : event.time_end_en}</span>}
                                </div>
                                <div className="event-wrapper">
                                    <div className={`event-content-wrapper ${(event.description || event.panel) ? 'has-open':''}`} onClick={() => (event.description || event.panel) && toggle(event.id)}>
                                        <div className="event-subtitle" dangerouslySetInnerHTML={{__html: lang==='pt' ? event.title : event.title_en}} />
                                        {(event.description || event.panel) &&
                                        <div id={`event_${event.id}`} className={`event-open`}>
                                            {event.description &&<div className={`event-description ${event.panel ? 'event-border-end':''}`} dangerouslySetInnerHTML={{__html: lang==='pt' ? event.description : event.description_en}} />}
                                            {event.panel &&<div className="event-description text-panel" dangerouslySetInnerHTML={{__html: lang==='pt' ? event.panel : event.panel_en}} />}
                                        </div>}
                                    </div>
                                    {event.title_2 &&
                                    <div className={`event-content-wrapper ${event.description_2 ? 'has-open':''}`} onClick={() => event.description_2 && toggle(`${event.id}_2`)}>
                                        <div className="event-subtitle" dangerouslySetInnerHTML={{__html: lang==='pt' ? event.title_2 : event.title_2_en}} />
                                        {event.description_2 &&
                                        <div id={`event_${event.id}_2`} className={`event-open`}>
                                            <div className={`event-description`} dangerouslySetInnerHTML={{__html: lang==='pt' ? event.description_2 : event.description_2_en}} />
                                        </div>}
                                    </div>}
                                    {event.title_3 &&
                                    <div className={`event-content-wrapper ${event.description_3 ? 'has-open':''}`} onClick={() => event.description_3 && toggle(`${event.id}_3`)}>
                                        <div className="event-subtitle" dangerouslySetInnerHTML={{__html: lang==='pt' ? event.title_3 : event.title_3_en}} />
                                        {event.description_3 &&
                                        <div id={`event_${event.id}_3`} className={`event-open`}>
                                            <div className={`event-description`} dangerouslySetInnerHTML={{__html: lang==='pt' ? event.description_3 : event.description_3_en}} />
                                        </div>}
                                    </div>}
                                </div>
                            </div>))}
                        </div>))}
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
